import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import SearshFilter from '../components/shared/SearshFilter'
import showDeptBalanceOrders from '../apis/showDeptBalanceOrders'
import showOnlineBalanceOrders from '../apis/showOnlineBalanceOrders'
import OrdersTable from '../components/orders/OrdersTable'

const BalanceOrders = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [sortType, setSortType] = useState('creationDate')
  const query = new URLSearchParams(location.search)
  const Ordertype = query.get('type') || 'online-payment'

  const handleTabClick = (newType) => {
    navigate(`/balance-orders?type=${newType}`)
  }

  const fetchData = useCallback(async () => {
    try {
      setData([])
      setLoading(true)
      let orders = []
      switch (Ordertype) {
        case 'dept-payment':
          orders = await showDeptBalanceOrders()
          break
        case 'online-payment':
          orders = await showOnlineBalanceOrders()
          break
        default:
          orders = []
          setLoading(false)
      }
      setData(orders)
      setFilteredData(orders)
    } catch (error) {
      setData([])
      console.error('Failed to fetch orders', error)
    } finally {
      setLoading(false)
    }
  }, [Ordertype])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const refresh = () => {
    fetchData()
  }

  useEffect(() => {
    if (!Array.isArray(data)) {
      setFilteredData([])
      return
    }

    const filtered = data.filter(
      (order) =>
        order.status?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.client_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (order.id && order.id?.toString().includes(searchTerm))
    )

    let sorted = [...filtered]
    if (sortType === 'alphabet' && Ordertype === 'dept-payment') {
      sorted = sorted.sort(
        (a, b) => parseFloat(b.amount) - parseFloat(a.amount)
      )
    } else if (sortType === 'alphabet' && Ordertype === 'online-payment') {
      sorted = sorted.sort(
        (a, b) => parseFloat(b.total_price) - parseFloat(a.total_price)
      )
    } else if (sortType === 'creationDate') {
      sorted = sorted.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      )
    } else {
      sorted = sorted.sort(
        (a, b) => parseFloat(b.total_price) - parseFloat(a.total_price)
      )
    }

    setFilteredData(sorted)
  }, [searchTerm, sortType, data, Ordertype])
  return (
    <>
      <div className="text-2xl text-blue-600 mb-4">Balance Orders</div>
      <SearshFilter
        type={'order'}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        sortType={sortType}
        setSortType={setSortType}
      />
      <div className="flex space-x-4 ">
        <button
          className={`py-2 px-4  ${
            Ordertype === 'online-payment'
              ? 'bg-blue-600 text-blueButton border-b-[2px] border-b-darkBlue'
              : ' text-gray'
          }`}
          onClick={() => handleTabClick('online-payment')}
        >
          Online Payment
        </button>
        <button
          className={`py-2 px-4  ${
            Ordertype === 'dept-payment'
              ? 'bg-blue-600 text-blueButton border-b-[2px] border-b-darkBlue '
              : 'text-gray'
          }`}
          onClick={() => handleTabClick('dept-payment')}
        >
          Dept Payment
        </button>
      </div>
      <div className="">
        {loading ? (
          <div>loading ... </div>
        ) : (
          <OrdersTable
            refresh={refresh}
            type={'balance-order'}
            data={filteredData}
          />
        )}
      </div>
    </>
  )
}

export default BalanceOrders
